/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.5",
    versionName: "0.2.0-nightly.2026.1.5",
    versionChannel: "nightly",
    buildDate: "2026-01-05T00:08:18.657Z",
    commitHash: "e84380c87eb9a46b1b5c547615711ed41e9c1b16",
};
